<script lang="ts">
const MAX_PERCENTAGE = 100;
const MIN_PERCENTAGE = 68;
const MAX_DELAY_MS = 1300;
function generateRandomLine(count: number) {
    const percentages = [];
    for (let i = 0; i < count; i++) {
        const randomWidth =
            Math.floor(Math.random() * (MAX_PERCENTAGE - MIN_PERCENTAGE + 1)) + MIN_PERCENTAGE;
        const randomDelay = Math.floor(Math.random() * MAX_DELAY_MS);
        percentages.push({
            key: Math.random(),
            width: `${randomWidth}%`,
            animationDelay: `${randomDelay}ms`,
        });
    }
    return percentages;
}
</script>
<script setup lang="ts">
import { computed, onMounted, ref, useTemplateRef } from "vue";

withDefaults(defineProps<{ mode: "blur" | "skeleton" }>(), {
    mode: "blur",
});

const noOfLines = ref(4);
const LINE_HEIGHT = 40;
const preloaderBox = useTemplateRef("preloaderBox");
const LINES = computed(() => generateRandomLine(noOfLines.value));
onMounted(() => {
    if (preloaderBox.value) {
        noOfLines.value = Math.round(preloaderBox.value.offsetHeight / LINE_HEIGHT);
    }
});
</script>

<template>
    <div
        ref="preloaderBox"
        class="z-10 p-3 h-full flex justify-center items-center flex-col gap-2 overflow-hidden"
        :class="{ 'backdrop-blur-[4px]': mode === 'blur' }"
    >
        <template v-if="mode === 'skeleton'">
            <div
                v-for="{ key, width, animationDelay } in LINES"
                :key="key"
                class="generation-bar w-full rounded-full"
                :style="{
                    width,
                    animationDelay,
                    backgroundColor: '#E8EAED',
                }"
            >
                &nbsp;
            </div>
        </template>
    </div>
</template>

<style scoped>
.generation-bar {
    animation: pulse 2s ease-out infinite;
}

@keyframes pulse {
    0% {
        opacity: 0.15;
    }
    50% {
        opacity: 1;
    }
    100% {
        opacity: 0.15;
    }
}
</style>
